import React from 'react';
import { useNavigate } from 'react-router-dom';
import './MobileBottomNav.css';

const MobileBottomNav = ({ activeTab, setActiveTab }) => {
  const navigate = useNavigate();

  return (
    <div className="mobile-bottom-nav">
      <button
        className={`mobile-nav-item ${activeTab === 'featured-athletes' ? 'active' : ''}`}
        onClick={() => navigate('/')}
      >
        <img
          src="/assets/images/featured-icon.png"
          alt="Featured"
          className="mobile-nav-icon"
        />
        <span className="mobile-nav-label">Featured Athletes</span>
      </button>

      <button
        className={`mobile-nav-item ${activeTab === 'get-featured' ? 'active' : ''}`}
        onClick={() => navigate('/get-featured')}
      >
        <img
          src="/assets/images/athlete-icon.png"
          alt="Athlete"
          className="mobile-nav-icon"
        />
        <span className="mobile-nav-label">Get Featured</span>
      </button>
    </div>
  );
};

export default MobileBottomNav;
